import { defineMessages } from 'react-intl';

export default defineMessages({
    Remove: {
        id: 'qnb.spt.SgSptWinterSportsTravellerDetailsLookup.Remove',
        defaultMessage: 'Remove'
    },
    Edit: {
        id: 'qnb.spt.SgSptWinterSportsTravellerDetailsLookup.Edit',
        defaultMessage: 'Add'
    },
    winterSportsLookupCoverPrice: {
        id: 'qnb.spt.SgSptWinterSportsTravellerDetailsLookup.winterSportsLookupCoverPrice',
        defaultMessage: '(£{cost})'
    },
    winterSportsExclusionMessage: {
        id: 'qnb.spt.SgSptWinterSportsTravellerDetailsLookup.exclusionMessage',
        defaultMessage: 'Cannot be added due to declared medical conditions'
    }
});
